import { Box, Container, Typography } from '@mui/material';
import { ReactSVG } from 'react-svg';
import errorSvg from '../../assets/icons/errors/under-construction.svg';


export const Maintenance = () => (
  <Container maxWidth={false} sx={{ width: 'fit-content' }}>
    <Box width="100%" display="flex" flexDirection="column" height="100vh">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <ReactSVG src={errorSvg} />
        <Typography
          sx={{
            marginTop: '40px',
            fontWeight: '700',
            fontSize: '20px',
          }}
        >
          Ведутся технические работы.
        </Typography>
        <Typography
          sx={{
            marginTop: '10px',
            fontWeight: '400',
            fontSize: '16px',
          }}
        >Совсем скоро всё заработает. Приносим извинения за причиненные неудобства.</Typography>
      </Box>
    </Box>
  </Container>
)
